export const COOKIE_KEYS = {
  statistic_consentGiven: 'statistic_consentGiven',
  cookie_cat_statistic: 'cookie_cat_statistic',
};
